<template>
	<div
		class="accommodationcard cell small-12 large-4"
		:class="{
			'accommodationcard--similar': isSimilarAcc,
			'accommodationcard--hover': hasHoverEffect,
			'accommodationcard--discount': isDiscount
		}"
	>
		<!-- Image -->
		<router-link
			:to="{ name: 'accommodation', ...urlToAccommodation() }"
			@click.native="pushGTM"
		>
			<img
				v-if="!isDiscount"
				class="accommodationcard__image"
				:height="imageHeight"
				:width="imageWidth"
				:src="getImgUrl(image, 'array')"
				:alt="title"
			/>
			<div v-if="isDiscount" class="accommodationcard__discountLabelWrapper">
				<img
					class="accommodationcard__image"
					:height="imageHeight"
					:width="imageWidth"
					:src="getImgUrl(image, 'array')"
					:alt="title"
				/>
				<span class="accommodationcard__discontLabel">
					<span class="accommodationcard__discontLabel__value">
						-{{ convertPrice(fullPrice - price) }} SEK
					</span>
				</span>
			</div>
			<div class="accommodationcard__container">
				<div class="accommodationcard__head">
					<span v-if="price != 0" class="accommodationcard__title">
						{{ title }}
					</span>
					<span
						v-else
						class="accommodationcard__title accommodationcard__title--full"
					>
						{{ title }}
					</span>

					<span
						v-if="price != 0 && !isDiscount"
						class="accommodationcard__price"
					>
						{{ convertPrice(price) }} SEK
					</span>
					<span
						v-if="price != 0 && isDiscount"
						class="accommodationcard__price"
					>
						<span class="accommodationcard__price__reduced">
							{{ convertPrice(price) }} SEK
						</span>
						<span class="accommodationcard__price__full">
							Ord. pris {{ convertPrice(fullPrice) }} SEK
						</span>
					</span>
				</div>

				<!-- Mandatory addons -->
				<div
					class="accommodationcard__labels"
					:title="'Inklusive: ' + mandatoryAddons().join(', ')"
					v-if="mandatoryAddons().length > 0"
				>
					<!-- Label -->
					<span class="accommodationcard__labels-headline">
						{{ $t('accommodation.including') }}:
					</span>

					<ul>
						<template v-for="addon in mandatoryAddons()">
							<li :key="mandatoryAddons().indexOf(addon)">{{ addon }}</li>
						</template>
					</ul>
				</div>

				<div class="accommodationcard__text" v-if="description">
					{{ description | truncate(200, ' ...') }}
				</div>
				<Accommodationinfo
					v-if="type && type != 'Campingplats'"
					:beds="beds"
					:bedrooms="bedrooms"
					:area="area"
					:distanceToLift="distanceToLift"
					:extraBeds="extraBeds"
					:loft="loft"
				/>
			</div>
		</router-link>

		<div class="accommodationcard__button">
			<router-link
				:to="{ name: 'accommodation', ...urlToAccommodation() }"
				@click.native="pushGTM"
			>
				<Button :full="true" size="small">
					{{ $t('accommodation.bookButton') }}
				</Button>
			</router-link>
		</div>
	</div>
</template>
<script>
import store from '../../vueX/store'
import mixin from '../../mixin'

import Accommodationinfo from '../molecules/AccommodationInfo'
import Button from '../atoms/Button'

export default {
	name: 'AccommodationCard',
	mixins: [mixin],
	components: {
		Accommodationinfo,
		Button
	},
	props: {
		id: {
			type: Number,
			default: 0
		},
		hasHoverEffect: {
			type: Boolean,
			default: false
		},
		image: {
			type: Array,
			default: () => []
		},
		placeholderImage: {
			type: String,
			default: 'https://boka.klappen.se/images/klappen_boende_fallback.jpg'
		},
		title: {
			type: String,
			default: 'default'
		},
		price: {
			type: [String, Number],
			default: ''
		},
		fullPrice: {
			type: [String, Number],
			default: ''
		},
		pricecode: {
			type: String,
			default: ''
		},
		description: {
			type: String,
			default: 'default'
		},
		type: {
			type: String,
			default: 'default'
		},
		beds: {
			type: Number,
			default: 0
		},
		bedrooms: {
			type: Number,
			default: 0
		},
		extraBeds: {
			type: Number,
			default: 0
		},
		loft: {
			type: Boolean,
			default: false
		},
		area: {
			type: Number,
			default: 0
		},
		distanceToLift: {
			type: Number,
			default: 0
		},
		isSimilarAcc: {
			type: Boolean,
			default: false
		},
		imageWidth: {
			type: Number,
			default: 360
		},
		imageHeight: {
			type: Number,
			default: 220
		},
		poollid: {
			type: Number,
			default: 0
		},
		unitlid: {
			type: Number,
			default: 0
		},
		showAddons: {
			type: Boolean,
			default: false
		},
		addons: {
			type: Array,
			default: () => []
		},
		plusaccommodation: {
			type: Boolean,
			default: false
		},
		departurecleaning: {
			type: Boolean,
			default: false
		},
		breakfastincluded: {
			type: Boolean,
			default: false
		},
		linensetincluded: {
			type: Boolean,
			default: false
		},
		totalPeople: {
			type: Number,
			default: 0
		}
	},
	filters: {
		truncate: function (text, length, suffix) {
			if (text && text.length > length) {
				var trimmedText = text.substring(0, length)
				trimmedText = trimmedText.substr(
					0,
					Math.min(trimmedText.length, trimmedText.lastIndexOf(' '))
				)
				return trimmedText + suffix
				//return text.substring(0, length) + suffix
			} else {
				return text
			}
		}
	},
	methods: {
		pushGTM() {
			store.dispatch('GTM_PUSH_ACCOMMODATION_CLICK', {
				title: this.title,
				price: this.price,
				unitlid: this.unitlid,
				type: this.type
			})
		},
		convertPrice(price) {
			return new Intl.NumberFormat(this.$t('currency')).format(price)
		},
		urlToAccommodation() {
			const query = this.$route.query

			return {
				params: {
					id: `${this.title.replace(/ /g, '-')}_${this.poollid}_${this.unitlid}`
				},
				query: {
					s: query.s ? query.s : undefined,
					e: query.e ? query.e : undefined,
					c: query.c ? query.c : undefined,
					y: query.y ? query.y : undefined,
					a: query.a ? query.a : 2,
					cc: query.cc ? query.cc : undefined
				}
			}
		},
		mandatoryAddons() {
			const mandatoryAddonsList = []

			//PLUS
			if (this.plusaccommodation) {
				mandatoryAddonsList.push(this.$t('accommodation.plusLabel'))
			}

			//Skipass
			if (this.pricecode != 'D') {
				const skipassAddons = []
				this.addons.forEach(function (addon) {
					if (addon.mandatory_web === true && addon.resvtypelid === 1001) {
						skipassAddons.push(addon.qty + ' Skipass')
					}
				})
				if (skipassAddons.length) {
					mandatoryAddonsList.push(skipassAddons[0])
				}
			}

			//Breakfast
			if (this.breakfastincluded) {
				mandatoryAddonsList.push(
					this.totalPeople + ' ' + this.$t('accommodation.breakfast')
				)
			}

			//Linen
			if (this.linensetincluded) {
				mandatoryAddonsList.push(
					this.totalPeople + ' ' + this.$t('cart.linenSet')
				)
			}

			//Departure cleaning
			if (this.departurecleaning) {
				mandatoryAddonsList.push(this.$t('cart.departureCleaning'))
			}

			return mandatoryAddonsList
		}
		// getDistanceToLift(distance) {
		// 	if (distance != null && distance.lift != null) {
		// 		return distance.lift
		// 	} else {
		// 		return ''
		// 	}
		// }
	},
	computed: {
		langUrl: function () {
			const getlangFromUrl = window.location.href.includes('/en/')
			if (getlangFromUrl) {
				return '/en/boka/'
			}
			return '/boka/'
		},
		datesAndPeople: function () {
			return store.state.accommodation.datesAndPeople
		},
		isDiscount: function () {
			return (
				this.fullPrice !== -1 &&
				this.fullPrice !== 0 &&
				this.fullPrice !== '' &&
				this.price !== -1 &&
				this.price !== 0 &&
				this.price !== ''
			)
		}
	}
}
</script>

<style scoped lang="scss">
.accommodationcard {
	position: relative;
	z-index: 1;
	transition: transform 0.3s ease-in-out;
	margin-bottom: 20px;

	&--discount {
		.accommodationcard {
			&__price {
				color: $colorRed;
			}

			&__discountLabelWrapper {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				flex-direction: row;
				position: relative;

				.accommodationcard__discontLabel {
					display: flex;
					align-items: center;
					padding: 0 4px;
					border-radius: 3px;
					background-color: #b9003c;
					position: absolute;
					bottom: 2px;
					right: 20px;
					color: #ffffff;

					@include for-phone-only {
						right: 0;
					}
				}

				.accommodationcard__discontLabel__value {
					font-size: 11px;
				}
			}
		}
	}

	&--hover {
		&:hover {
			@include for-tablet-portrait-up {
				z-index: 2;
				transform: scale(1.1);
				background: #fff;
				box-shadow: 0px 50px 100px 0px rgba(0, 0, 0, 0.35);
				a {
					transform: scale(0.9);
				}
				.accommodationcard__button {
					display: block;
				}
			}
		}
		a {
			transition: transform 0.3s ease-in-out;
			display: block;
			&:hover {
				text-decoration: none;
			}
		}
	}

	&__container {
		position: relative;
		@include for-tablet-portrait-up {
			padding: 0px 20px 20px 20px;
		}
	}

	&--similar {
		max-width: 375px;

		img {
			padding: 10px 0;
		}
		.accommodationcard__container {
			padding: 10px 0;
		}
	}

	&__image {
		display: inline-block;
		width: 100%;
		height: 220px;
		max-height: 220px;
		background-size: cover;
		background-repeat: no-repeat;
		box-sizing: border-box;
		padding: 10px 20px;
		object-fit: cover;

		img {
			width: 100%;
			visibility: hidden;
		}

		@include for-phone-only {
			padding: 10px 0;
		}
	}

	&__head {
		display: flex;
		justify-content: space-between;
		align-items: baseline;
		margin-bottom: 15px;
	}

	&__title {
		color: $colorGrey8;
		font-family: Saira;
		font-size: 20px;
		line-height: 1.4;
		//white-space: nowrap;
		//overflow: hidden;
		//text-overflow: ellipsis;
		max-width: 50%;
		&--full {
			max-width: 100%;
		}
	}

	&__price {
		color: $colorPrimary;
		font-family: Saira;
		font-size: 22px;
		line-height: 1.4px;
		font-weight: 500;

		&__reduced {
			display: flex;
			flex-direction: column;
			justify-content: flex-end;
			align-items: flex-end;
			width: 100%;
			line-height: 28px;
		}

		&__full {
			color: #697791;
			font-size: 11px;
			font-weight: 500;
			letter-spacing: 0;
			line-height: 17px;
			display: flex;
			justify-content: flex-end;
			align-items: flex-end;
		}
	}

	&__labels {
		margin: -15px 0 8px 0;

		&-headline {
			display: inline-block;
			text-transform: uppercase;
			color: $colorGrey8;
			font-size: 10px;
			font-weight: 500;
			margin-bottom: 3px;
		}

		ul {
			overflow: hidden;
			white-space: nowrap;
			position: relative;

			&:after {
				content: '';
				display: block;
				width: 93px;
				height: 100%;
				position: absolute;
				top: 0;
				right: 0;
				z-index: 1;
				background: linear-gradient(
					90deg,
					rgba(255, 255, 255, 0) 0%,
					#ffffff 100%
				);
			}
		}

		li {
			display: inline-block;
			background: $colorPrimary1;
			margin: 0 5px 5px 0;
			padding: 5px 8px;
			border-radius: 4px;
			font-size: 13px;
			line-height: 15px;
			color: $colorPrimary8;
		}
	}

	&__rating {
		height: 10px;
	}

	&__text {
		color: $colorGrey8;
		font-family: Saira;
		font-size: 14px;
		line-height: 24px;
		padding-bottom: 15px;
	}

	&__info {
		display: flex;
		&--item {
			color: $colorGrey8;
			font-family: Saira;
			font-size: 12px;
			line-height: 18px;
			padding: 10px 20px;
			&:first-child {
				padding: 10px 20px 10px 0px;
			}
			&:nth-child(even) {
				border-left: 1px solid $colorPrimary2;
				border-right: 1px solid $colorPrimary2;
			}
		}
		span {
			display: block;
		}
	}

	&__icon {
		width: 24px;
		height: 24px;
		fill: $colorPrimary6;
	}

	&__button {
		display: block;
		position: relative;
		bottom: 0;
		width: 100%;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		padding: 20px 0;
		background-color: $colorWhite;
		@include for-tablet-portrait-up {
			display: none;
			position: absolute;
			bottom: -40px;
			padding: 0 20px 20px 20px;
		}
	}
}
</style>
